import { DetailsTreeItemValue } from "@synota-io/synota-shared-ui";
import { InvoiceData } from "../../../../api/hooks/useInvoiceDetails";

export function scalarsToTree(data: InvoiceData): DetailsTreeItemValue[] {
  return [
    {
      id: "scalars_root",
      label: "Scalars",
      children: Object.keys(data.scalars).length
        ? Object.entries(data.scalars).map(([key, scalar]) => {
            const children: DetailsTreeItemValue[] = [
              {
                id: `scalar_${key}_value`,
                label: "Value",
                value: scalar.value,
              },
            ];

            if (Object.keys(scalar.descriptors).length > 0) {
              children.push({
                id: `scalar_${key}_descriptors`,
                label: "Descriptors",
                children: Object.entries(scalar.descriptors).map(([dKey, dValue]) => ({
                  id: `scalar_${key}_descriptor_${dKey}`,
                  label: dKey,
                  value: dValue,
                })),
              });
            }

            if (Object.keys(scalar.numeric_descriptors).length > 0) {
              children.push({
                id: `scalar_${key}_numeric_descriptors`,
                label: "Numeric Descriptors",
                children: Object.entries(scalar.numeric_descriptors).map(([dKey, dValue]) => ({
                  id: `scalar_${key}_numeric_descriptor_${dKey}`,
                  label: dKey,
                  value: dValue,
                })),
              });
            }

            return {
              id: `scalar_${key}`,
              label: key,
              children,
            };
          })
        : [
            {
              id: "scalars_empty",
              label: "",
              render: () => "No scalars found.",
            },
          ],
    },
  ];
}

export function intervalsToTree(data: InvoiceData): DetailsTreeItemValue[] {
  return [
    {
      id: "intervals_root",
      label: "Intervals",
      children: Object.keys(data.intervals).length
        ? Object.entries(data.intervals).map(([key, interval]) => {
            const children: DetailsTreeItemValue[] = [];

            if (interval.values.length > 0) {
              children.push({
                id: `interval_${key}_values`,
                label: "Values",
                list: interval.values.map((value, index) => ({
                  id: `interval_${key}_value_${index}`,
                  label: `Value ${index + 1}`,
                  value: value ?? "-",
                })),
              });
            }

            if (Object.keys(interval.descriptors).length > 0) {
              children.push({
                id: `interval_${key}_descriptors`,
                label: "Descriptors",
                children: Object.entries(interval.descriptors).map(([dKey, dValue]) => ({
                  id: `interval_${key}_descriptor_${dKey}`,
                  label: dKey,
                  value: dValue,
                })),
              });
            }

            if (Object.keys(interval.numeric_descriptors).length > 0) {
              children.push({
                id: `interval_${key}_numeric_descriptors`,
                label: "Numeric Descriptors",
                children: Object.entries(interval.numeric_descriptors).map(([dKey, dValue]) => ({
                  id: `interval_${key}_numeric_descriptor_${dKey}`,
                  label: dKey,
                  value: dValue,
                })),
              });
            }

            return {
              id: `interval_${key}`,
              label: key,
              children:
                children.length > 0
                  ? children
                  : [
                      {
                        id: `interval_${key}_empty`,
                        label: "",
                        render: () => "No data available.",
                      },
                    ],
            };
          })
        : [
            {
              id: "intervals_empty",
              label: "",
              render: () => "No intervals found.",
            },
          ],
    },
  ];
}
